<template>
	<div>
		<h3 class="text-center">Prelievi di Potenza [kW]</h3>
		<div id="power-line-chart" style="height: 500px"></div>
	</div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
	name: "PowerLineChart",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,
		}
	},
	mounted() {
		var chart = am4core.create("power-line-chart", am4charts.XYChart);

		/**
		 * [
				{
					"value": 10,
					"yearMonth": 202101
				},
				{
					"value": 9,
					"yearMonth": 202201
				},
				{
					"value": 10,
					"yearMonth": 202102
				},
				{
					"value": 9,
					"yearMonth": 202202
				},
				{
					"value": 10,
					"yearMonth": 202103
				},
				{
					"value": 9,
					"yearMonth": 202203
				}
			]
		 */
		const data = this.data.map((item) => {
			const year = String(item.yearMonth).slice(0, 4);
			const month = parseInt(String(item.yearMonth).slice(4, 6));

			return {
				value: item.value,
				year: year,
				month: this.$store.state.utils.months[month - 1],
			};
		});
		chart.data = data;
	
		let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "month";
		categoryAxis.renderer.grid.template.location = 0;

		let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.min = 0;

		const years = [...new Set(chart.data.map((item) => item.year))];
		years.forEach((year, index) => {
			var seriesColor = this.colors[index];
			const series = chart.series.push(new am4charts.ColumnSeries());
			series.dataFields.valueY = "value";
			series.dataFields.categoryX = "month";
			series.name = year + '';
			series.stacked = false;
			series.data = data.filter(e => e.year == year);
			series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
			series.stroke = am4core.color(seriesColor);
			series.columns.template.fill = am4core.color(seriesColor);
		})

		chart.legend = new am4charts.Legend();
	},
	methods: {		
	},
	computed: {		
		monthsNames() {
			return this.$store.state.utils.months;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/PowerLineChart.vue